var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgShoppingCart = function SvgShoppingCart(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.97 9.243-2.81 11.242A2 2 0 0 1 25.219 22H7.89a2 2 0 0 1-1.986-1.768L3.879 4H2.5a1.5 1.5 0 1 1 0-3h2.687a1.5 1.5 0 0 1 1.486 1.296L7.455 8H29a1 1 0 0 1 .97 1.243M7 27c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3-3 1.346-3 3M25 27c0-1.654-1.346-3-3-3s-3 1.346-3 3 1.346 3 3 3 3-1.346 3-3"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShoppingCart);
export default ForwardRef;